module.exports = __webpack_public_path__ + "cash.png?6aeb7ecd61f265514c2b1c0f93b437d8";